import CategorySearch from 'marketing/components/CategorySearch';
import CategoriesView from 'marketing/components/CategoriesView';
import FullTextSearch from 'marketing/utils/FullTextSearch';
import { trackLink, trackEvent } from '@99designs/common/utils/platform';
import CategoriesMenu from 'marketing/components/CategoriesMenu';
import { scrollOnHover } from 'marketing/components/scrollable';
import FullscreenOverlay from 'marketing/components/FullscreenOverlay';
import { scrollToElement } from 'common/utils/scroll';
import Cookies from 'cookies-js';

let isFlashSaleActive = false;

const parentCategoryToQueryParamMapping = {
    logo: 'logo-identity',
    'website-app-design': 'web-app-design',
    'business-advertising': 'business-advertising',
    'clothing-merchandise-design': 'clothing-merchandise',
    'art-illustration': 'art-illustration',
    'packaging-label-design': 'packaging-label',
    'book-magazine-design': 'book-magazine',
};

document.addEventListener('DOMContentLoaded', () => {
    const categoriesView = document.querySelector('[data-categories-view]');
    const heroLink = document.querySelector('[data-categories-hero-link]');

    if (heroLink) {
        trackClickedHeroLink(heroLink);
    }

    let fullscreenOverlays;

    new CategoriesView(categoriesView);
    new CategorySearch({
        searcher: initializeSearcher(),
        onChange: () => {
            updateColor();
            cleanupModals(fullscreenOverlays);
            fullscreenOverlays = initializeModals();

            if (isFlashSaleActive) {
                showFlashSaleCallouts();
            }
        },
    });
    new CategoriesMenu({
        onChange: () => {
            updateColor();
            triggerUserBrowsingEvent();
        },
    });

    initializeLinkTracking(categoriesView);
    runScrollable();
    fullscreenOverlays = initializeModals();
    initializeScrollToSearch();
    setQualarooCookieOnClickedLogoCategoryMenu();
    setQueryParamForParentCategories();
});

function initializeSearcher() {
    const searchConfig = [
        {
            name: 'title',
            weight: 0.8,
        },
        {
            name: 'parent',
            weight: 0.4,
        },
        {
            name: 'keywords',
            weight: 0.2,
        },
    ];
    const searchdocuments = readCategoriesData();
    const fallBackResult = searchdocuments
        .filter(doc => {
            return doc.key === 'other-design';
        })
        .pop();

    return new FullTextSearch(searchdocuments, searchConfig, fallBackResult);
}

function initializeScrollToSearch() {
    const searchAnchor = document.querySelector('[data-scrollto-search]');
    const searchTitle = document.querySelector('[data-category-menu-search-title]');

    if (searchAnchor) {
        searchAnchor.addEventListener('click', e => {
            e.preventDefault();
            scrollToElement(searchTitle, 0, 500, triggerUserSearchIntent);
        });
    }
}

function setQualarooCookieOnClickedLogoCategoryMenu() {
    const cookieKey = 'qualarooLogoIdentity';
    const qualarooCookie = Cookies.get(cookieKey);
    const logoAndIdentity = document.querySelector('[data-category-menu="logo"]');

    if (logoAndIdentity && !qualarooCookie) {
        logoAndIdentity.addEventListener('click', e => {
            Cookies.set(cookieKey, true, { expires: 24 * 60 * 60 });
        });
    }
}

function readCategoriesData() {
    const categories = [];

    window.categories.forEach(category => {
        const categoryNode = document.querySelector(`[data-category-${category.key}]`);

        if (categoryNode) {
            const clone = categoryNode.cloneNode(true);
            initializeLinkTracking(clone);

            categories.push({
                title: category.title,
                parent: category.parent_category_title,
                keywords: category.keywords.join(' '),
                node: clone,
                key: category.key,
            });
        }
    });

    return categories;
}

function initializeLinkTracking(element) {
    const categoryLinks = element.querySelectorAll('[data-categories-cta]');

    Array.from(categoryLinks).forEach(categoryLink => {
        categoryLink.addEventListener('click', trackClickedLink);
    });
}

function trackClickedLink(event) {
    const searchBox = document.querySelector('[data-search-field]');

    trackEvent('Clicked CTA on Categories Page', {
        cta_category: event.currentTarget.getAttribute('data-categories-cta-category'),
        cta_location: event.currentTarget.getAttribute('data-categories-cta-location'),
        searchTerm: searchBox ? searchBox.value : null,
    });
}

function trackClickedHeroLink(element) {
    element.addEventListener('click', event => {
        trackEvent('Hero Carousel Banner on Categories Page Clicked', {
            tracking_key: event.currentTarget.getAttribute(
                'data-categories-hero-link-tracking-key'
            ),
        });
    });
}

function runScrollable() {
    scrollOnHover();
}

function initializeModals() {
    const modals = document.querySelectorAll('[data-fullscreen-overlay-id]');

    const fullscreenOverlayList = Array.from(modals).map(
        modal =>
            new FullscreenOverlay({
                element: modal,
                options: {
                    fixedViewport: true,
                    onClose: () =>
                        trackEvent('Dismissed Categories Product Selection Modal', {
                            fullscreen_overlay_id: modal.getAttribute('data-fullscreen-overlay-id'),
                        }),
                    onOpen: () =>
                        trackEvent('Viewed Categories Product Selection Modal', {
                            fullscreen_overlay_id: modal.getAttribute('data-fullscreen-overlay-id'),
                        }),
                },
            })
    );

    return fullscreenOverlayList;
}

function cleanupModals(modals) {
    Array.from(modals).forEach(modal => {
        modal.cleanup();
    });
}

function updateColor() {
    let colorHex = '#752873';

    const activeCategoryGroup = Array.from(
        document.querySelectorAll('[data-category-group]')
    ).filter(group => {
        return group.hasAttribute('data-active');
    })[0];

    const activeCarouselItem = activeCategoryGroup.querySelector(
        '[data-slide-carousel-content][data-carousel-active=true]'
    );

    if (activeCarouselItem) {
        colorHex = activeCarouselItem.querySelector('[data-color]').getAttribute('data-color');
    }

    Array.from(document.querySelectorAll('[data-categories-chameleon-element]')).forEach(
        element => {
            element.style.color = colorHex;
        }
    );
}

function triggerUserBrowsingEvent() {
    triggerCustomEvent('UserBrowsingCategories');
}

function triggerUserSearchIntent() {
    triggerCustomEvent('UserWantsToSearchCategories');
}

function triggerCustomEvent(eventName) {
    let customEvent;

    if (typeof Event === 'function') {
        customEvent = new Event(eventName);
    } else {
        // For IE11
        customEvent = document.createEvent('Event');
        customEvent.initEvent(eventName, true, true);
    }

    document.dispatchEvent(customEvent);
}

document.addEventListener('DOMContentLoaded', () => {
    const modalCtas = document.querySelectorAll(
        '[data-fullscreen-overlay-id] [data-categories-cta]'
    );

    Array.from(modalCtas).forEach(element => {
        trackLink(element, 'Clicked CTA on Categories Page', {
            cta_location: element.getAttribute('data-categories-cta-location'),
            cta_category: element.getAttribute('data-categories-cta-category'),
        });
    });

    fetch('/start/xhr/coupon')
        .then(response => response.json())
        .then(data => {
            if (
                data &&
                data.promotion &&
                window.flashSaleConfig &&
                data.promotion.campaign === window.flashSaleConfig.name
            ) {
                isFlashSaleActive = true;
                showFlashSaleCallouts();
            }
        });
});

function showFlashSaleCallouts() {
    const elements = Array.from(document.querySelectorAll('[data-flash-sale-callout]'));
    elements.forEach(element => {
        element.removeAttribute('data-hidden');
    });

    const placeholders = Array.from(document.querySelectorAll('[data-flash-sale-placeholder]'));
    placeholders.forEach(element => {
        element.setAttribute('data-hidden', '');
    });
}

function setQueryParamForParentCategories() {
    const parentCategoryButtons = document.querySelectorAll('[data-parent-category]');
    if (parentCategoryButtons) {
        const paramName = 'section';
        const urlSearchParams = new URLSearchParams(window.location.search);
        parentCategoryButtons.forEach((parentCategoryButton, idx) => {
            parentCategoryButton.addEventListener('click', e => {
                e.preventDefault();
                var categoryMenuName = parentCategoryButton.dataset.categoryMenu;
                urlSearchParams.set(paramName, parentCategoryToQueryParamMapping[categoryMenuName]);

                const newURL = window.location.pathname + '?' + urlSearchParams.toString();
                history.pushState(null, null, newURL);
            });
        });
    }
}
